import { Validate, Num, Formatter, Calendar } from '@/utils/index'

const filters = {
  /**
   * 处理无正负号的金额千分位, 主要用于后端已经处理了小数位数的数据, 例如交易记录中的份额金额等
   * @param {} val
   * @returns
   */
  thousandthValWithNoSign(val) {
    if (Validate.isEmpty(val)) {
      return ''
    }
    let newVal = Number(val)
    if (Validate.isEmpty(newVal)) {
      return '--'
    } else if (typeof newVal === 'number') {
      return newVal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }
  },
  formatAsset(val, useSymbol, vm) {
    if (vm && !vm.isEyeAssets) {
      return '****'
    }

    if (val == null) {
      return '--'
    }

    if (val != 0 && !String(val).includes('-') && useSymbol) {
      return `+${Num.toThousands(val, 2)}`
    }

    return Num.toThousands(val, 2)
  },
  //接受数据范例0.8  -0.8 0.8% -0.8% 返回数据范例 --  +0.80 -0.80 +0.80% -0.80%
  //symbol为true代表要加正负号 ，percentFlag代表是否要加%
  formatPercent(val, symbol = true, percentFlag = true) {
    if (Validate.isEmpty(val) || val == '--') {
      return '-'
    }
    if (typeof val == 'string' && val.indexOf('%') != -1) {
      val = Number(val.replace('%', ''))
    }
    if (symbol) {
      //是否前面要加+-号
      if (val > 0) {
        val = percentFlag
          ? '+' + Num.vnum4Percentage(val, 2, true) + '%'
          : '+' + Num.vnum4Percentage(val, 2, true)
      } else {
        val = percentFlag
          ? Num.vnum4Percentage(val, 2, true) + '%'
          : Num.vnum4Percentage(val, 2, true)
      }
    } else {
      val = percentFlag
        ? Num.vnum4Percentage(val, 2, true) + '%'
        : Num.vnum4Percentage(val, 2, true)
    }
    if (~val.indexOf('NaN')) {
      val = '--'
    }
    return val
  },
  /**
   * 处理金额千分位, 及判断万元, 例如安稳定投中的预算投入等金额
   * 处理银行卡单笔单日限额判断
   * @param {} val
   * @returns
   */
  toThousandthWithWan(val) {
    if (isNaN(val)) {
      return ''
    }
    let newVal = Number(val)
    let wanSign = ''
    if (newVal > 10000 || newVal < -10000) {
      newVal = newVal / 10000
      wanSign = '万'
    }
    // return newVal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + wanSign;
    return Math.floor(newVal * 100) / 100 + wanSign
  },
  /**
   * 处理金额中文位数
   * @param {} val
   * @returns
   */
  formatMoneyUnit(val) {
    if (Number(val) >= 1e8) {
      return '亿'
    } else if (Number(val) >= 1e7) {
      return '千万'
    } else if (Number(val) >= 1000000) {
      return '百万'
    } else if (Number(val) >= 100000) {
      return '十万'
    } else if (Number(val) >= 10000) {
      return '万'
    } else if (Number(val) >= 1000) {
      return '千'
    } else {
      return ''
    }
  },
  formatStringToSymbol(dateString, symbol = '-') {
    if (dateString && dateString.length == 8) {
      return `${dateString.substring(0, 4)}${symbol}${dateString.substring(4, 6)}${symbol}${dateString.substring(6, 8)}`
    } else if (dateString) {
      return dateString
    } else {
      return '-'
    }
  },
  formatToCNMoney(val) {
    return Formatter.moneyToCN(val)
  },
  /**
   * 处理日期为*月*日
   * @param {} val
   * @returns
   */
  formatToMD(val) {
    return Calendar.format(val, 'MM月DD日')
  },
  /**
   * 处理日期为*年*月*日
   * @param {} val
   * @returns
   */
  formatToYMD(val) {
    return Calendar.format(val, 'YYYY年MM月DD日')
  },
  /**
   * 处理日期为*年*月*日
   * @param {} val
   * @returns
   */
  formatToWeekDay(val) {
    return Calendar.toWeek(val)
  }
}

export default (vm) => {
  Object.keys(filters).forEach((key) => {
    vm.filter(key, filters[key])
  })
}



// WEBPACK FOOTER //
// ./src/filters/commonFilter.js